/* wd-flow-klaviyo: shared notify-form -> Klaviyo Client Subscriptions binding
   for wd-flow-* landing pages. Port of wonderful-flow-landing/shared/klaviyo.js,
   scoped to .wd-flow-notify-form and exposed as window.WDFlowKlaviyo so it never
   collides with the theme's existing window.KlaviyoLeadSubmission global. */
(function () {
  'use strict'
  try {
    var KLAVIYO_COMPANY_ID = 'LmwnMm'
    var KLAVIYO_NOTIFY_LIST_ID = 'WQdn2Y'

    /* custom_source values Klaviyo shows on the profile / subscription */
    var KLAVIYO_NOTIFY_SOURCES = {
      mystery: 'Flow Notify — Mystery',
      band: 'Flow Notify — Band'
    }

    /* Meta (Facebook) custom conversion events, one per campaign page, fired
       once Klaviyo has accepted the signup. The store's pixel normally runs
       inside Shopify's sandboxed web-pixel frame (Facebook & Instagram app),
       where page code cannot reach it, so the pixel script is loaded here,
       on demand, only at the moment of a successful signup: no extra
       PageView, automatic events off, nothing loaded for visitors who never
       sign up. */
    var FB_PIXEL_ID = '2388738294803616'
    var FB_SIGNUP_EVENTS = {
      mystery: 'wd_flow_mystery_signup',
      band: 'wd_flow_change_signup'
    }
    /* What Meta stores with the event. Deliberately neutral: these pages run
       before the reveal, so nothing sent from them may name the product. */
    var FB_SIGNUP_LABELS = {
      mystery: 'Mystery signup',
      band: 'Band signup'
    }

    /* Shopify's Customer Privacy API, when the store has it on the page;
       without it (no consent banner in this region) marketing is allowed. */
    function marketingAllowed() {
      try {
        var cp = window.Shopify && window.Shopify.customerPrivacy
        if (cp && typeof cp.marketingAllowed === 'function') return !!cp.marketingAllowed()
      } catch (err) {}
      return true
    }

    function ensureFbq() {
      if (window.fbq) return window.fbq
      /* Meta's standard base-code loader, minus its automatic PageView */
      !function (f, b, e, v, n, t, s) {
        if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments) }
        if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = []
        t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s)
      }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')
      window.fbq('set', 'autoConfig', false, FB_PIXEL_ID)
      window.fbq('init', FB_PIXEL_ID)
      return window.fbq
    }

    function trackSignup(page) {
      var name = FB_SIGNUP_EVENTS[page]
      if (!name) return
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({ event: name, page: page })
      if (!FB_PIXEL_ID || !marketingAllowed()) return
      try {
        ensureFbq()('trackCustom', name, { content_name: FB_SIGNUP_LABELS[page] || 'Signup' })
      } catch (err) {
        if (window.console) console.error('[wd-flow-klaviyo] Meta event failed', err)
      }
    }

    function pageKey(form) {
      var fromForm = form && form.getAttribute('data-notify-page')
      if (fromForm) return fromForm
      var path = (location.pathname || '').replace(/\/+$/, '')
      var slug = path.split('/').pop()
      return slug && slug !== '' ? slug : 'unknown'
    }

    function sourceFor(page) {
      return KLAVIYO_NOTIFY_SOURCES[page] || ('Flow Notify — ' + page)
    }

    /* What Klaviyo itself accepts, checked before anything is sent: one @,
       no spaces, a dot in the domain and a 2+ letter ending. Klaviyo answers
       anything looser with a 400, which used to surface as an unexplained
       failed signup. */
    var EMAIL_RE = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)*\.[A-Za-z]{2,}$/

    function isValidEmail(value) {
      return EMAIL_RE.test(value) && value.length <= 254
    }

    /* Native browser bubble on the field (the form is novalidate, so the
       browser only shows it when asked); cleared as soon as they type. */
    function flagField(field, message) {
      field.setCustomValidity(message)
      field.setAttribute('aria-invalid', 'true')
      field.reportValidity()
      field.focus()
    }

    function subscribeNotify(email, page) {
      return sendSubscription(email, page).then(function (status) { return status === 202 })
    }

    /* Resolves to Klaviyo's HTTP status (202 = subscribed), or 0 when the
       request never got an answer. */
    function sendSubscription(email, page) {
      var key = page || 'unknown'
      var source = sourceFor(key)

      if (!KLAVIYO_NOTIFY_LIST_ID) {
        if (window.console) console.warn('[wd-flow-klaviyo] KLAVIYO_NOTIFY_LIST_ID is empty — capture stayed local only')
        return Promise.resolve(202)
      }

      var options = {
        method: 'POST',
        headers: {
          revision: '2024-05-15',
          'content-type': 'application/json'
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: source,
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    properties: {
                      'Notify page': key,
                      'Notify source': source
                    }
                  }
                }
              }
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: KLAVIYO_NOTIFY_LIST_ID
                }
              }
            }
          }
        })
      }

      return fetch(
        'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(KLAVIYO_COMPANY_ID),
        options
      ).then(function (response) {
        if (response.status !== 202 && window.console) console.error('[wd-flow-klaviyo] unexpected status', response.status)
        return response.status
      }).catch(function (error) {
        if (window.console) console.error('[wd-flow-klaviyo] Error sending lead data:', error)
        return 0
      })
    }

    function bindNotifyForm(form) {
      if (!form || form.getAttribute('data-klaviyo-bound') === '1') return
      form.setAttribute('data-klaviyo-bound', '1')

      var input = form.querySelector('input[type="email"]')
      if (input) input.addEventListener('input', function () {
        input.setCustomValidity('')
        input.removeAttribute('aria-invalid')
      })

      form.addEventListener('submit', function (e) {
        e.preventDefault()
        var field = form.querySelector('input[type="email"]')
        var button = form.querySelector('button[type="submit"]')
        if (!field) return
        var email = field.value.trim()
        if (!isValidEmail(email)) {
          flagField(field, email ? 'Please enter a valid email address, like name@example.com.' : 'Please enter your email address.')
          return
        }
        field.value = email

        var page = pageKey(form)
        if (button) button.disabled = true

        sendSubscription(email, page).then(function (status) {
          if (status !== 202) {
            if (button) button.disabled = false
            /* a 4xx is Klaviyo refusing the address itself; anything else is
               the network or Klaviyo having a moment */
            flagField(field, status >= 400 && status < 500
              ? 'That email address doesn’t look right. Please check it and try again.'
              : 'Something went wrong. Please try again in a moment.')
            return
          }
          try { localStorage.setItem('wd-flow-notify-email', email) } catch (err) {}
          form.classList.add('sent')
          window.dataLayer = window.dataLayer || []
          window.dataLayer.push({
            event: 'notify_request',
            email_captured: true,
            page: page,
            klaviyo: !!KLAVIYO_NOTIFY_LIST_ID
          })
          trackSignup(page)
        })
      })
    }

    function bindAll() {
      var forms = document.querySelectorAll('.wd-flow-notify-form')
      for (var i = 0; i < forms.length; i++) bindNotifyForm(forms[i])
    }

    window.WDFlowKlaviyo = {
      subscribeNotify: subscribeNotify,
      isValidEmail: isValidEmail,
      bindNotifyForm: bindNotifyForm,
      bindAll: bindAll,
      trackSignup: trackSignup,
      sources: KLAVIYO_NOTIFY_SOURCES,
      fbSignupEvents: FB_SIGNUP_EVENTS
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bindAll)
    } else {
      bindAll()
    }
  } catch (err) {
    if (window.console) console.error('[wd-flow-klaviyo] init failed', err)
  }
})()
